/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

const lewooPayClient = axios.create();
const lewooPayAuthClient = axios.create({
  baseURL: "http://62.171.179.132:3200",
});

const buildWalletRequestConfig = (token, config = {}) => ({
  ...config,
  headers: {
    ...(config.headers || {}),
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    "x-tenant-slug": "default",
  },
});

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  createLewooPayWallet: (data) => {
    return lewooPayAuthClient.post(API_ENDPOINTS.LEWOO_PAY_REGISTER, data, {
      headers: {
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getLewooPayMe: (token) => {
    return lewooPayClient.get(API_ENDPOINTS.LEWOO_PAY_ME, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getuserWalletList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_USERWALLET, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getusersWalletLogs: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_USERWALLET_LOGS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  addwalletmoney: (data) => {
    return axios.post(API_ENDPOINTS.ADD_WALLET_AMOUNT, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  getdriverWalletList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_DRIVERWALLET, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getdriversWalletLogs: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_DRIVERWALLET_LOGS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  // addwalletmoney: (id, data) => {
  //   let url = API_ENDPOINTS.ADD_WALLET_AMOUNT + "/" + id;
  //   return axios.put(url, data, {
  //     headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
  //   });
  // },
  getManagerDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_MANAGER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  addManager: (data) => {
    return axios.post(API_ENDPOINTS.ADD_MANAGER, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data","x-tenant-slug":"default" },
    });
  },
  deleteManager: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_MANAGER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  getClientWallets: (token, config = {}) => {
    return axios.get(API_ENDPOINTS.GET_CLIENT_WALLETS, buildWalletRequestConfig(token, { suppressForbiddenRedirect: true, ...config }));
  },
  createClientWallet: (token, data) => {
    return axios.post(API_ENDPOINTS.CREATE_CLIENT_WALLET, data, {
      suppressForbiddenRedirect: true,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  syncClientWallet: (id, token, config = {}) => {
    return axios.post(
      `${API_ENDPOINTS.SYNC_CLIENT_WALLET_BASE}/${id}/sync`,
      {},
      buildWalletRequestConfig(token, { suppressForbiddenRedirect: true, ...config })
    );
  },
  getClientWalletTransactions: (id, token, params = {}, config = {}) => {
    return axios.get(`${API_ENDPOINTS.GET_CLIENT_WALLET_TRANSACTIONS_BASE}/${id}/transactions`, {
      ...buildWalletRequestConfig(token, { suppressForbiddenRedirect: true, ...config }),
      params,
    });
  },
  getClientPaymentMethods: (token) => {
    return axios.get(API_ENDPOINTS.GET_CLIENT_PAYMENT_METHODS, {
      suppressForbiddenRedirect: true,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  addClientPaymentMethod: (token, data) => {
    return axios.post(API_ENDPOINTS.CREATE_CLIENT_PAYMENT_METHOD, data, {
      suppressForbiddenRedirect: true,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  createPaypalOrder: (token, data, config = {}) => {
    return axios.post(API_ENDPOINTS.CREATE_PAYPAL_ORDER, data, buildWalletRequestConfig(token, { suppressForbiddenRedirect: true, ...config }));
  },
  capturePaypalOrder: (token, orderId, config = {}) => {
    return axios.post(
      `${API_ENDPOINTS.CREATE_PAYPAL_ORDER}/${orderId}/capture`,
      {},
      buildWalletRequestConfig(token, { suppressForbiddenRedirect: true, ...config })
    );
  },
};
